import React from 'react';

// Real HDFC-Parivartan logo lockup — served from /public/brand/parivartan-logo.png
// Compact (icon-rail) mode shows only the HDFC mark using object-fit crop.
export default function Logo({ compact = false }) {
  return (
    <div
      data-testid="parivartan-logo"
      style={{
        background: '#fff',
        borderRadius: 10,
        padding: compact ? 6 : '10px 12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
        marginBottom: 18,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {compact ? (
        // Icon rail: crop to just the HDFC BANK mark on the left (approx first 22% of image width)
        <div style={{ width: 40, height: 40, overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
          <img
            src={`${process.env.PUBLIC_URL || ''}/brand/parivartan-logo.png`}
            alt="HDFC Bank Parivartan"
            style={{ height: 40, width: 'auto', objectFit: 'contain', objectPosition: 'left center' }}
          />
        </div>
      ) : (
        <img
          src={`${process.env.PUBLIC_URL || ''}/brand/parivartan-logo.png`}
          alt="HDFC Bank Parivartan — A step towards sustainable progress"
          style={{ width: '100%', height: 'auto', display: 'block' }}
        />
      )}
    </div>
  );
}
